export class Permissoes {
	static ALTERAR_LOGO_EMPRESA: Permissoes = new Permissoes('ALTERAR_LOGO_EMPRESA');
	static APK: Permissoes = new Permissoes('APK');
	static ATIVA_INATIVAR_CARREGAMENTO_ENTREGA: Permissoes = new Permissoes('ATIVA_INATIVAR_CARREGAMENTO_ENTREGA');
	static CADASTRO_CENTRO_DISTRIBUICAO: Permissoes = new Permissoes('CADASTRO_CENTRO_DISTRIBUICAO');
	static CADASTRO_CONTATO: Permissoes = new Permissoes('CADASTRO_CONTATO');
	static CADASTRO_DESPESA: Permissoes = new Permissoes('CADASTRO_DESPESA');
	static CADASTRO_LOCALIZACAO_CLIENTE: Permissoes = new Permissoes('CADASTRO_LOCALIZACAO_CLIENTE');
	static CADASTRO_PERFIL_ACESSO: Permissoes = new Permissoes('CADASTRO_PERFIL_ACESSO');
	static CADASTRO_USUARIO: Permissoes = new Permissoes('CADASTRO_USUARIO');
	static CONEXOES: Permissoes = new Permissoes('CONEXOES');
	static CONFIGURACOES: Permissoes = new Permissoes('CONFIGURACOES');
	static CONFIGURACOES_EMAIL: Permissoes = new Permissoes('CONFIGURACOES_EMAIL');
	static DASHBOARD: Permissoes = new Permissoes('DASHBOARD');
	static DETALHE_CARREGAMENTO: Permissoes = new Permissoes('DETALHE_CARREGAMENTO');
	static DETALHE_CLIENTE: Permissoes = new Permissoes('DETALHE_CLIENTE');
	static DETALHE_DESCARGA_CANCELADA: Permissoes = new Permissoes('DETALHE_DESCARGA_CANCELADA');
	static DETALHE_ENTREGA: Permissoes = new Permissoes('DETALHE_ENTREGA');
	static DETALHE_EVENTO: Permissoes = new Permissoes('DETALHE_EVENTO');
	static DETALHE_HODOMETRO: Permissoes = new Permissoes('DETALHE_HODOMETRO');
	static GRAFICOS: Permissoes = new Permissoes('GRAFICOS');
	static IMPORTAR_LOCALIZACAO_ERP: Permissoes = new Permissoes('IMPORTAR_LOCALIZACAO_ERP');
	static INCENTIVO_MOTORISTA: Permissoes = new Permissoes('INCENTIVO_MOTORISTA');
	static MAPA_ENTREGAS: Permissoes = new Permissoes('MAPA_ENTREGAS');
	static MOTIVO_CANCELAMENTO: Permissoes = new Permissoes('MOTIVO_CANCELAMENTO');
	static MOTIVO_FURO_SEQUENCIA: Permissoes = new Permissoes('MOTIVO_FURO_SEQUENCIA');
	static NIVEL_SERVICO_LOGISTICO: Permissoes = new Permissoes('NIVEL_SERVICO_LOGISTICO');
	static NOTIFICACOES: Permissoes = new Permissoes('NOTIFICACOES');
	static PAINEL_MONITORAMENTO: Permissoes = new Permissoes('PAINEL_MONITORAMENTO');
	static PAINEL_SOLICITACOES: Permissoes = new Permissoes('PAINEL_SOLICITACOES');
	static PARAMETROS_DISPOSITIVO: Permissoes = new Permissoes('PARAMETROS_DISPOSITIVO');
	static PARAMETROS_PORTAL: Permissoes = new Permissoes('PARAMETROS_PORTAL');
	static PEDIDOS_ATRASADOS: Permissoes = new Permissoes('PEDIDOS_ATRASADOS');
	static PESQUISA_CARREGAMENTO: Permissoes = new Permissoes('PESQUISA_CARREGAMENTO');
	static PESQUISA_CENTRO_DISTRIBUICAO: Permissoes = new Permissoes('PESQUISA_CENTRO_DISTRIBUICAO');
	static PESQUISA_CLIENTE: Permissoes = new Permissoes('PESQUISA_CLIENTE');
	static PESQUISA_CONTATO: Permissoes = new Permissoes('PESQUISA_CONTATO');
	static PESQUISA_DESCARGA_CANCELADA: Permissoes = new Permissoes('PESQUISA_DESCARGA_CANCELADA');
	static PESQUISA_DESPESA: Permissoes = new Permissoes('PESQUISA_DESPESA');
	static PESQUISA_ENTREGA: Permissoes = new Permissoes('PESQUISA_ENTREGA');
	static PESQUISA_EVENTO: Permissoes = new Permissoes('PESQUISA_EVENTO');
	static PESQUISA_HODOMETRO: Permissoes = new Permissoes('PESQUISA_HODOMETRO');
	static PESQUISA_PERFIL_ACESSO: Permissoes = new Permissoes('PESQUISA_PERFIL_ACESSO');
	static PESQUISA_USUARIO: Permissoes = new Permissoes('PESQUISA_USUARIO');
	static RANK: Permissoes = new Permissoes('RANK');
	static RELATORIOS: Permissoes = new Permissoes('RELATORIOS');
	static MONITORAMENTO_MOTORISTAS: Permissoes = new Permissoes('MONITORAMENTO_MOTORISTAS');
	static SLA: Permissoes = new Permissoes('SLA');
	static TIPO_DESPESA: Permissoes = new Permissoes('TIPO_DESPESA');
	static TIPO_EVENTO: Permissoes = new Permissoes('TIPO_EVENTO');
	static TITULOS_RECEBIVEIS: Permissoes = new Permissoes('TITULOS_RECEBIVEIS');
	static VISAO_TATICO_OPERACIIONAL: Permissoes = new Permissoes('VISAO_TATICO_OPERACIIONAL');
	static PAINEL_CONTROLE_PORTARIA: Permissoes = new Permissoes('PAINEL_CONTROLE_PORTARIA');
	static PERMITIR_LANCAR_ALTERAR_DESPESAS: Permissoes = new Permissoes('PERMITIR_LANCAR_ALTERAR_DESPESAS');
	static PERMITIR_ANALISAR_SOLICITACAO_DEVOLUCAO: Permissoes = new Permissoes('PERMITIR_ANALISAR_SOLICITACAO_DEVOLUCAO');
	static CADASTRO_VISAO_GERENCIAL: Permissoes = new Permissoes('CADASTRO_VISAO_GERENCIAL');
	static PERMITE_EXCLUIR_JORNADA_TRABALHO: Permissoes = new Permissoes('PERMITE_EXCLUIR_JORNADA_TRABALHO');
	static PERMITIR_EDITAR_REGISTRO_JORNADA_INSERIDO: Permissoes = new Permissoes('PERMITIR_EDITAR_REGISTRO_JORNADA_INSERIDO');
	static PERMITIR_INCLUSAO_MANUAL_REGISTRO_JORNADA: Permissoes = new Permissoes('PERMITIR_INCLUSAO_MANUAL_REGISTRO_JORNADA');
	static CADASTROS: Permissoes = new Permissoes('CADASTROS');
	static CONSULTAS: Permissoes = new Permissoes('CONSULTAS');
	static AUTORIZACOES: Permissoes = new Permissoes('AUTORIZACOES');
	static TORRE_DE_CONTROLE: Permissoes = new Permissoes('TORRE_DE_CONTROLE');
	private innerValor;

	constructor(valor) {
		this.innerValor = valor;
	}

	getValor() {
		return this.innerValor;
	}

}
